import { configureStore } from "@reduxjs/toolkit";
import { authSlice } from "./features/auth-slice";
import { taskSlice } from "./features/task-slice";
import { otherSlice } from "./features/other-slice";
import { commonSlice } from "./features/common-slice";
import { reportSlice } from "./features/report-slice";
import { userSlice } from "./features/user-slice";
import { misaSlice } from "./features/misa-slice";
import { documentSlice } from "./features/document-slice";
import { dReportSlice } from "./features/design-report-slice";
import { weeklySummarySlice } from "./features/weekly-summary-slice";
import { experienceSlice } from "./features/experience-slice";
import { customerSlice } from "./features/customer-slice";
import { categorySlice } from "./features/category-slice";
import {scheduleExportSlice} from "./features/schedule-export.slice";
import { incidentSlice } from "./features/incident-slice";
import { courseSlice } from "./features/course-slice";
import { jdSlice } from "./features/jd-slice";
import { candidateSlice } from "./features/candidate-slice";

const store = configureStore({
  reducer: {
    [authSlice.name]: authSlice.reducer,
    [userSlice.name]: userSlice.reducer,
    [taskSlice.name]: taskSlice.reducer,
    [otherSlice.name]: otherSlice.reducer,
    [commonSlice.name]: commonSlice.reducer,
    [reportSlice.name]: reportSlice.reducer,
    [documentSlice.name]: documentSlice.reducer,
    [misaSlice.name]: misaSlice.reducer,
    [dReportSlice.name]: dReportSlice.reducer,
    [weeklySummarySlice.name]: weeklySummarySlice.reducer,
    [experienceSlice.name]: experienceSlice.reducer,
    [customerSlice.name]: customerSlice.reducer,
    [categorySlice.name]: categorySlice.reducer,
    [scheduleExportSlice.name]: scheduleExportSlice.reducer,
    [incidentSlice.name]: incidentSlice.reducer,
    [courseSlice.name]: courseSlice.reducer,
    [jdSlice.name]: jdSlice.reducer,
    [candidateSlice.name]: candidateSlice.reducer,
  },
  devTools: true,
});

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
